import  { HttpClient }  from "../api/httpclient.service";


export class ExerciseService extends HttpClient {

    constructor() {
        super()
    }

    public async fetchExercise(levelId: number, topicId: number, difficultyId: number, offset: number){
      try {
        console.log("Fetching exercise...");
        const response = await this.get(`/data/search_exercise?level_id=${levelId}&topic_id=${topicId}&difficulty_id=${difficultyId}&limit=1&offset=${offset}`);
        return await response;
      } catch (error) {
        console.error("Error fetching exercise:", error);
        return null;
      }
    }

    public async fetchExerciseFromUser(sessionId: string){
      try {
        console.log("Fetching exercise...");
        const response = await this.get(`/capture/get_validate_exercise/${sessionId}`);
        return await response;
      } catch (error) {
        console.error("Error fetching exercise:", error);
        return null;
      }  
    }

    public async fetchClasess(){
      try {
        const response = await this.get(`/data/get_classes`);
        return await response;
      } catch (error) {
        console.error("Error fetching classes:", error);
        return null;
      }  
    }

}


// export const fetchDifferentExercise = async (): Promise<any> => {
//   try {
//     console.log("Fetching different exercise...");
//     const randomExercise = exerciseMock.exercises[1]; // Fetch different exercise
//     console.log("Fetched data:", randomExercise);
//     return randomExercise;
//   } catch (error) {
//     console.error("Error fetching different exercise:", error);
//     return null;
//   }
// };
